import { QueryClient } from "@tanstack/react-query";

export function createQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				// Stale after 30 seconds — the data changes infrequently
				staleTime: 30_000,
				// Cache for 5 minutes
				cacheTime: 5 * 60_000,
				// Don't refetch on window focus during active review sessions
				refetchOnWindowFocus: false,
				// Retry once on failure, then show error
				retry: 1,
				retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
			},
			mutations: {
				// Retry mutations once (network flakes)
				retry: 1,
			},
		},
	});
}
